module.exports = __webpack_public_path__ + "img/chevron-right.29e9d830.svg";